module.exports = __webpack_public_path__ + "static/media/status_1.bd453ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/carRentPayment/images/status_1.png
// module id = 609
// module chunks = 0